module.exports = __webpack_public_path__ + "img/mobile/Background-bonus/background_bonus@3x.jpg?0.0.53";